module.exports = __webpack_public_path__ + "img/about大图2.f68d1c7c.jpg";